import { SYSTEM_CONTEXT_IDS } from 'modules/niche/common/niche.consts'

import type { TBrandContentType } from './brands.types'

export const PAGE_NAME = 'Brand Page'

export const BLOCK_MESSAGE_SPLIT_PATTERN = /^([\s\S]*!)\s*([\s\S]*)$/

export const NICHE_CONTEXT_ID_BY_CONTENT_TYPE = {
  total: SYSTEM_CONTEXT_IDS.happeningNow,
  owned: SYSTEM_CONTEXT_IDS.launches,
  earned: SYSTEM_CONTEXT_IDS.happeningNow,
  paid: SYSTEM_CONTEXT_IDS.paidPartnership,
} as const satisfies Record<TBrandContentType, string>

export const BRAND_CONTENT_TYPE_MAP = {
  BrandGroup: 'total',
  selfContent: 'owned',
  earned: 'earned',
  paid: 'paid',
} as const satisfies Record<string, TBrandContentType>

export const TERRITORY_KEY_BY_CONTENT_TYPE = {
  total: 'groupedTerritory',
  owned: 'selfContentTerritory',
  earned: 'earnedTerritory',
  paid: 'paidTerritory',
} as const satisfies Record<TBrandContentType, string>

export const CONTENT_TYPE_BY_TERRITORY_KEY = {
  groupedTerritory: 'total',
  selfContentTerritory: 'owned',
  earnedTerritory: 'earned',
  paidTerritory: 'paid',
} as const satisfies Record<string, TBrandContentType>

export const TIME_UNIT_MAP: Record<string, 'day' | 'week' | 'quarter' | 'month'> = {
  today: 'day',
  '0': 'day',
  '24h': 'day',
  '3': 'week',
  '1': 'week',
  '24': 'quarter',
  '36': 'quarter',
  '61': 'quarter',
  '12': 'month',
  '6': 'month',
}
